module.exports = __webpack_public_path__ + "static/media/WhatWeDo2.08207b5a.svg";